var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 50.5858C8.50858 48.238 3.96717 41.9771 4.72407 31.8032C5.48097 21.6293 22.8897 -3.41413 38.0277 1.28151C50.1381 5.19455 56.9502 17.7163 54.6795 34.151C52.4088 50.5858 47.8674 53.7162 43.326 52.9336C38.7846 52.151 33.4863 51.3684 28.9449 51.3684C24.4035 51.3684 19.1052 55.2814 12.2931 50.5858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3458 50.5008L12.3459 50.5007L12.3498 50.5034C15.7306 52.8339 18.7314 53.0276 21.4564 52.639C22.5836 52.4782 23.6622 52.2181 24.7044 51.9667C24.9252 51.9134 25.1444 51.8606 25.3621 51.8091C26.6039 51.5156 27.7967 51.2684 28.9449 51.2684C33.4956 51.2684 38.8012 52.0524 43.343 52.835C44.4643 53.0283 45.5803 52.9792 46.6594 52.5473C47.7385 52.1154 48.7887 51.2975 49.7733 49.9401C51.7453 47.2215 53.4457 42.3506 54.5805 34.1373C56.8466 17.7358 50.0483 5.27092 37.9975 1.37684C34.2445 0.212896 30.3451 0.889837 26.588 2.72867C22.8302 4.5679 19.221 7.56677 16.0568 11.0337C12.8931 14.5002 10.1778 18.4308 8.20654 22.1288C6.23405 25.8292 5.01151 29.2875 4.8238 31.8106C4.06942 41.9506 8.59558 48.1743 12.3458 50.5008Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3295",
    x: 0.640625,
    y: 0.701172,
    width: 58.4688,
    height: 60.3418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3295",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth26);
export default __webpack_public_path__ + "static/media/teeth26.f70d45c94684ab7c647133ec9486b91f.svg";
export { ForwardRef as ReactComponent };